(()=>{
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(()=>{
    const toggle = document.querySelector('.pb-nav__toggle');
    const nav = document.getElementById('pb-primary-nav');
    if (toggle && nav){
      toggle.addEventListener('click', ()=>{
        const open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open? 'true':'false');
      });
    }
    const header = document.querySelector('.pb-header');
    if (header) {
      const onScroll = ()=>{
        if (window.scrollY > 10) { header.style.boxShadow = '0 4px 10px rgba(0,0,0,.06)'; }
        else { header.style.boxShadow = 'none'; }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();

